import styled, { css } from 'styled-components'

import {
  DeprecatedText,
  ResponsiveImage,
  Skeleton,
  TypeStyle,
  fromMd,
  pageLayoutMaxWidth,
} from '@syconium/little-miss-figgy'

export const Background = styled.div<{ hideIfViewportGreaterThanOrEqualMd: boolean }>`
  display: block;
  width: 100%;

  ${fromMd} {
    background-color: ${o => o.theme.color.deprecated.stoneLighter};
    display: ${o => (o.hideIfViewportGreaterThanOrEqualMd ? 'none' : 'block')};
  }
`

export const TextContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 20px 16px;

  ${fromMd} {
    padding: 42px 0;
    margin-left: auto;
    margin-right: auto;
    max-width: calc(${pageLayoutMaxWidth} * 0.7);
  }
`

export const WhyWeLoveText = styled(TypeStyle.BodyDefault)<{
  hideIfViewportGreaterThanOrEqualMd: boolean
}>`
  color: ${o => o.theme.color.deprecated.obsidian};
  text-align: center;
  margin: 0 0 20px;
  max-width: 432px;
  text-align: center;
  width: 100%;

  ${fromMd} {
    display: ${o => (o.hideIfViewportGreaterThanOrEqualMd ? 'none' : 'block')};
  }
`

export const WhyWeLoveIconSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  row-gap: ${props => props.theme.spacing(6)};
  max-width: ${pageLayoutMaxWidth};
  overflow: hidden;
`

export const WhyWeLoveIconContainer = styled.div<{ wrapTwo?: boolean }>`
  flex: 1;
  min-width: min(50%, 100px);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-left: -1px;
  margin-right: -1px;
  @media (max-width: 432px) {
    flex-basis: ${o => o.wrapTwo && '50%'};
  }
  ${fromMd} {
    min-width: min(50%, 200px);
    padding: 10px 47px;
    &:not(:first-of-type) {
      border-inline-start: 1px solid ${o => o.theme.color.deprecated.stoneDark};
    }
  }
`

const iconCss = css`
  height: 48px;
  margin-bottom: 8px;
  width: 48px;

  ${fromMd} {
    height: 38px;
    width: 38px;
  }
`

export const Icon = styled(ResponsiveImage)`
  ${iconCss}
`

export const IconSkeleton = styled(Skeleton)`
  ${iconCss}
`

export const IconTitle = styled(DeprecatedText)`
  color: ${o => o.theme.color.deprecated.obsidianLight};
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  line-height: 1.82;
  text-align: center;
  text-transform: uppercase;
  width: 100%;

  ${fromMd} {
    font-size: 12px;
    font-weight: 600;
    max-width: unset;
    white-space: nowrap;
  }
`
